import { render, staticRenderFns } from "./UpdateProduct.vue?vue&type=template&id=e436d25a"
import script from "./UpdateProduct.vue?vue&type=script&lang=js"
export * from "./UpdateProduct.vue?vue&type=script&lang=js"
import style0 from "./UpdateProduct.vue?vue&type=style&index=0&id=e436d25a&prod&lang=scss"
import style1 from "./UpdateProduct.vue?vue&type=style&index=1&id=e436d25a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports